import React from "react";
import Sidebar from '../components/sidebar';
import Header from "../components/header";
import Footer from "../components/footer";
import { Outlet } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DashboardLayout = () => {
    return (
        <>
            <div className="page-wrapper" id="main-wrapper" data-layout="vertical" data-navbarbg="skin6" data-sidebartype="full"
                data-sidebar-position="fixed" data-header-position="fixed">
                <Sidebar />
                <div className="body-wrapper">
                    <Header />
                    <div className="container-fluid">
                        <Outlet />
                        <Footer/>
                    </div>
                    <ToastContainer />
                </div>
            </div>
        </>
    )
}
export default DashboardLayout;